const rhythm = val => (`${1.5 * val}rem`)
export {
  rhythm,
}
